import * as React from 'react';

export const SmallCarryOnIcon = (
	<svg width="55" height="67" viewBox="0 0 55 67" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M4.93142 17.8468L2.20248 55.3468C1.82305 60.5608 5.9509 65 11.1787 65H43.8213C49.0491 65 53.177 60.5608 52.7975 55.3468L50.0686 17.8468C49.7262 13.1421 45.8094 9.5 41.0923 9.5H13.9077C9.19057 9.5 5.27379 13.1421 4.93142 17.8468Z"
			stroke="#3C3C3C"
			stroke-width="3"
		/>
		<path
			d="M10.2367 20.5931L7.99381 53.5931C7.75824 57.059 10.5061 60 13.98 60H40.5153C43.9892 60 46.7371 57.059 46.5015 53.5931L44.2586 20.5931C44.0446 17.4446 41.4282 15 38.2724 15H16.2229C13.0671 15 10.4507 17.4446 10.2367 20.5931Z"
			fill="#D8D8D8"
		/>
		<path
			d="M13.6165 65V61C13.6165 57.6863 16.3027 55 19.6165 55H35.8883C39.202 55 41.8883 57.6863 41.8883 61V65"
			stroke="#3C3C3C"
			stroke-width="3"
		/>
		<path
			d="M10.5874 10L13.142 39.5173C13.4105 42.6189 16.0065 45 19.1197 45H36.3852C39.4984 45 42.0944 42.6189 42.3629 39.5173L44.9175 10"
			stroke="#3C3C3C"
			stroke-width="3"
		/>
		<path
			d="M20.6846 10V8C20.6846 4.68629 23.3709 2 26.6846 2H28.8205C32.1342 2 34.8205 4.68629 34.8205 8V10"
			stroke="#3C3C3C"
			stroke-width="3"
		/>
		<path
			d="M24.7234 46V46.9709C24.7234 48.6438 26.0796 50 27.7525 50V50C29.4255 50 30.7816 48.6438 30.7816 46.9709V46"
			stroke="#3C3C3C"
			stroke-width="3.5"
		/>
	</svg>
);
